var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevron = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46967 12.5302C6.17678 12.2373 6.17678 11.7624 6.46967 11.4696L9.93934 7.99989L6.46967 4.53022C6.17678 4.23732 6.17678 3.76245 6.46967 3.46956C6.76256 3.17666 7.23744 3.17666 7.53033 3.46956L11.5303 7.46956C11.8232 7.76245 11.8232 8.23732 11.5303 8.53022L7.53033 12.5302C7.23744 12.8231 6.76256 12.8231 6.46967 12.5302Z",
    fill: "#A1A7B2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChevron);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_chevron.21f0ee173c5a0f33cbf2463a5730a5ce.svg";